import { render, staticRenderFns } from "./procurementBidding.vue?vue&type=template&id=4926b536&scoped=true"
import script from "./procurementBidding.vue?vue&type=script&lang=js"
export * from "./procurementBidding.vue?vue&type=script&lang=js"
import style0 from "./procurementBidding.vue?vue&type=style&index=0&id=4926b536&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4926b536",
  null
  
)

export default component.exports